(function(){
  'use strict';
  window.SpiritPath = window.SpiritPath || {};

  window.SpiritPath.addToCartAndCheckout = function(button){
    var variantId = window.SpiritPath.product && window.SpiritPath.product.id;
    if (!variantId){
      window.location.href = '/products';
      return;
    }
    var result = window.SpiritPath.quizResult || {};
    var properties = {};
    if (result.name) properties['Name'] = result.name;
    if (result.worryType) properties['Worry Type'] = result.worryType;

    var originalText = button.textContent;
    button.textContent = 'Adding to cart…';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties }]
      })
    })
    .then(function(res){
      if (!res.ok) throw new Error('add-to-cart-failed');
      return res.json();
    })
    .then(function(){
      window.location.href = '/checkout';
    })
    .catch(function(){
      button.textContent = originalText;
      button.disabled = false;
      window.location.href = '/cart';
    });
  };

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-buy-now]');
    if (btn) window.SpiritPath.addToCartAndCheckout(btn);
  });
})();
